import { render, staticRenderFns } from "./contentHerder.vue?vue&type=template&id=1f45bb50&scoped=true"
import script from "./contentHerder.vue?vue&type=script&lang=js"
export * from "./contentHerder.vue?vue&type=script&lang=js"
import style0 from "./contentHerder.vue?vue&type=style&index=0&id=1f45bb50&prod&lang=scss&scoped=true"
import style1 from "./contentHerder.vue?vue&type=style&index=1&id=1f45bb50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f45bb50",
  null
  
)

export default component.exports